import React from 'react'
import { Skeleton } from '@mantine/core'
import SimpleSlider from '@/components/simple-slider'

type Props = {
  similarPropertyIsLoading?: boolean
}

const SimilarPropertyIsLoading = ({ similarPropertyIsLoading }: Props) => {
  if (similarPropertyIsLoading) {
    return (
      <div className='space-y-5'>
        {/* Title Skeleton */}
        <Skeleton height={28} width={200} radius='md' className='mb-5' />

        <div className=''>
          <SimpleSlider
            className='w-full'
            settings={{
              dots: false,
              arrows: false,
              autoplay: false,
              slideSize: {
                base: '100%',
                sm: '50%',
                md: '33.333333%',
                lg: '25%',
              },
              slideGap: {
                base: '28px',
                sm: 'md',
                md: '28px',
              },
              emblaOptions: {
                dragFree: true,
                align: 'start',
                slidesToScroll: 1,
                containScroll: 'trimSnaps',
                loop: false,
              },
            }}
          >
            {[...Array(6)].map((_, index) => (
              <div key={index} className='h-full'>
                {/* Property Card Skeleton */}
                <div className='space-y-4'>
                  {/* Image Skeleton - matches your rounded design */}
                  <Skeleton
                    height={300}
                    radius='lg'
                    className='w-full aspect-square rounded-[20px]'
                  />

                  {/* Content Section */}
                  <div className='mt-4 space-y-3 ml-[10px]'>
                    {/* Title Skeleton */}
                    <Skeleton
                      height={20}
                      radius='sm'
                      className='w-full max-w-[27ch]'
                    />

                    {/* Location & Rating Row */}
                    <div className='flex justify-between items-center'>
                      {/* Location Skeleton */}
                      <div className='flex items-center gap-1'>
                        <Skeleton circle height={18} width={18} />
                        <Skeleton height={16} radius='sm' width={90} />
                      </div>

                      {/* Rating Skeleton */}
                      <Skeleton height={32} radius='21px' width={80} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </SimpleSlider>
        </div>
      </div>
    )
  }
}

export default SimilarPropertyIsLoading
